import { render, staticRenderFns } from "./dmTable.vue?vue&type=template&id=5cd05ddd&"
import script from "./dmTable.vue?vue&type=script&lang=js&"
export * from "./dmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports